import { publicUrlFor } from '../../../globals/constants';

export default function SectionServiceContent({ service, _data }) {
	console.log(_data?.subSection?.image, 'section-service-content.jsx line 4');
	return (
		<>
			<h2 className='service-category-title'>{service}</h2>
			<div className='wt-media'>
				<img src={publicUrlFor(_data?.image)} alt='#' />
			</div>
			<h2 className='wt-title mt-4 mb-4'>{_data?.title}</h2>
			<p>{_data?.description}</p>

			<h3 className='wt-title mt-4 mb-4'>{_data?.subSection?.title}</h3>
			<div className='service-offered'>
				<div className='media'>
					<img src={publicUrlFor(_data?.subSection?.image)} alt='#' />
				</div>
				<div className='service-offered-list ms-4'>
					<p>{_data?.subSection?.description}</p>
					<div className='tw-checked-list'>
						<ul>
							{_data?.subSection?.points?.map((p) => (
								<li>{p}</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</>
	);
}
